import Glide from '@glidejs/glide';

let glide = new Glide('#testimonials', {
  type: 'carousel',
  perView: 1,
  focusAt: 'center'
});
glide.mount();


let glide2 = new Glide('#gallery', {
  type: 'carousel',
  perView: 2,
  focusAt: 'center',
  autoplay: 8000,
  breakpoints: {
    1000: {
      perView: 1,
      autoplay: false
    }
  },
});
glide2.mount();
